// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge___n10c","badgeBg":"Badge_badgeBg__Vg_P_"};